import PropTypes from "prop-types";

import { Loader } from "components/Loader";
import { Accordion } from "components/Accordion";
import { Heading } from "style/components/Heading.styles";
import { FAQContainer, HelpCenterSubCardContainer } from "../FAQ.styles";
import { useFaqs } from "features/HelpCenter/hook";

const FAQ = () => {
  const { isLoading, faqs } = useFaqs();

  return (
    <HelpCenterSubCardContainer>
      <FAQContainer>
        <div className="wrapper">
          <div className="header">
            <Heading>{`FAQ's`}</Heading>
            <p>Everything you need to know about Surmount.</p>
          </div>

          {isLoading ? <Loader /> : <Accordion items={faqs} />}

          {!isLoading && faqs.length === 0 && <div>{`No FAQ's Found!`}</div>}
        </div>
      </FAQContainer>
    </HelpCenterSubCardContainer>
  );
};

FAQ.propTypes = {
  handleMenuClose: PropTypes.func,
};

export { FAQ };
